import {MouseEvent} from 'react';

import type {AppState} from "@stores/AppState";
import type {ItemModelType} from "@stores/WorkspaceStore";


export interface OpenDocumentContextMenuOptions {
    item: ItemModelType;
    event?: MouseEvent<HTMLElement>;
    setIsOpen?: (isOpen: boolean) => void;
    targetDom?: HTMLElement;
    withOverlay?: boolean;
}

export const openDocumentContextMenu = (
    appState: AppState,
    {
        item,
        event,
        setIsOpen,
        targetDom,
        withOverlay = false,
    }: OpenDocumentContextMenuOptions
) => {
    if (appState.contextMenu?.type === 'document') {
        appState.setContextMenu(null);
    } else {
        if (setIsOpen) {
            setIsOpen(true)
        }

        appState.addAdditionalContextMenu({
            clientX: event?.clientX,
            clientY: event?.clientY,
            type: 'document',
            id: item.id,
            menuPlacement: 'block-end',
            menuAlignment: 'center',
            withPointer: false,
            VERTICAL_SHIFT: 4,
            getTargetBoundingBox: targetDom ? () => targetDom.getBoundingClientRect() : undefined,
            onClose: () => {
                if (setIsOpen) {
                    setIsOpen(false)
                }
                if (appState.rootStore.view.workspace?.confirmDeleteOpenUnder === 'document-context-menu') {
                    appState.rootStore.view.workspace!.setConfirmDeleteOpen(undefined);
                }
            },
            minWidth: 285,
            isPointerLarge: false,
            params: {
                itemId: item.id,
            },
            withOverlay: withOverlay,
        });
    }
}